"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Base = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = _interopRequireDefault(require("./utils"));

var _styles = require("./styles");

var _skyScrapper = _interopRequireDefault(require("./sky-scrapper"));

var _cube = _interopRequireDefault(require("./cube"));

var _penta = _interopRequireDefault(require("./penta"));

var _pyramid = _interopRequireDefault(require("./pyramid"));

var _tent = _interopRequireDefault(require("./tent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Base = function Base(props) {
  var a11yTitle = props.a11yTitle,
      boundaryX = props.boundaryX,
      boundaryY = props.boundaryY,
      borderWidth = props.borderWidth,
      borderColor = props.borderColor,
      cb = props.cb,
      chartBg = props.chartBg,
      elevation = props.elevation,
      _props$round = props.round,
      round = _props$round === void 0 ? false : _props$round,
      scaling = props.scaling,
      _props$shades = props.shades,
      shades = _props$shades === void 0 ? [_styles.colors.accent, _styles.colors.accent_pro] : _props$shades,
      size = props.size,
      variant = props.variant;

  var spread_props = function spread_props(item_props) {
    return _objectSpread({}, variant === 'skyscraper' && {
      elevation: elevation
    }, {
      onClick: cb,
      round: round,
      scaling: scaling,
      shades: shades,
      size: size,
      stroke_width: borderWidth,
      stroke: borderColor
    }, item_props);
  };

  return _react["default"].createElement("svg", {
    "aria-label": a11yTitle ? a11yTitle : "".concat(a11yTitle, ", a ").concat(variant),
    style: {
      background: chartBg,
      overflow: 'visible'
    },
    viewBox: "".concat(boundaryX, " ").concat(boundaryY, " ").concat(size, " ").concat(size),
    width: size,
    height: size
  }, {
    cube: _react["default"].createElement(_cube["default"], spread_props()),
    pyramid: _react["default"].createElement(_pyramid["default"], spread_props()),
    skyscraper: _react["default"].createElement(_skyScrapper["default"], spread_props()),
    pentagon: _react["default"].createElement(_penta["default"], spread_props()),
    tent: _react["default"].createElement(_tent["default"], spread_props())
  }[variant]);
};

exports.Base = Base;

var props_equal = function props_equal(prevProps, nextProps) {
  return prevProps.variant === nextProps.variant; // when the function returns true, component will not be re-rendered
};

var BaseMemoized = (0, _react.memo)(function (props) {
  return _react["default"].createElement(Base, props);
}, props_equal);
var Shape3D = {
  Cube: function Cube(props) {
    return _react["default"].createElement(BaseMemoized, _extends({
      variant: "cube"
    }, props));
  },
  Pyramid: function Pyramid(props) {
    return _react["default"].createElement(BaseMemoized, _extends({
      variant: "pyramid"
    }, props));
  },
  Tent: function Tent(props) {
    return _react["default"].createElement(BaseMemoized, _extends({
      variant: "tent"
    }, props));
  },
  SkyScraper: function SkyScraper(props) {
    return _react["default"].createElement(BaseMemoized, _extends({
      variant: "skyscraper"
    }, props));
  },
  Pentagon: function Pentagon(props) {
    return _react["default"].createElement(BaseMemoized, _extends({
      variant: "pentagon"
    }, props));
  }
};
var _default = Shape3D;
exports["default"] = _default;
Base.propTypes = {
  a11yTitle: _propTypes["default"].string,
  boundaryX: _propTypes["default"].number,
  boundaryY: _propTypes["default"].number,
  chartBg: _propTypes["default"].string,
  cb: _propTypes["default"].func,

  /**
   * only for <Shape3D.SkyScraper/>
   */
  elevation: _propTypes["default"].number,
  shades: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].string]),
  borderWidth: _propTypes["default"].number,
  borderColor: _propTypes["default"].string,
  size: _propTypes["default"].number,
  scaling: _propTypes["default"].number,
  variant: _propTypes["default"].oneOf(['cube', 'pyramid', 'pentagon', 'skyscraper', 'tent'])
};
Base.defaultProps = {
  boundaryX: 0,
  boundaryY: 0,
  cb: function cb() {},
  elevation: 30,
  scaling: 1,
  size: 100,
  chartBg: 'transparent',
  shades: _styles.colors.accent,
  a11yTitle: 'A 3D shape',
  borderWidth: 1,
  borderColor: 'transparent'
};